import { getCompanyConfig } from '@api/companyConfig';
import { normalizeSpeakUpCompanyConfigStrings } from '@helpers/speakUpConfig.helper';
import { normalizeTraumaCompanyConfigStrings } from '@helpers/traumaConfig.helper';
import { AppDispatch } from '@hooks/useAppDispatch';
import {
  DEFAULT_HS_BLUE_COLOR,
  TALK_TO_ADVISOR_COMPLETE_DEFAULT_MESSAGE,
  TALK_TO_ADVISOR_DEFAULT_MESSAGE,
} from 'custom.d';
import { companyConfigActions } from 'store/Slices/CompanyConfigSlice';

export const getCompanyConfigurations = () => async (dispatch: AppDispatch) => {
  dispatch(companyConfigActions.setLoading({ loading: true }));

  try {
    const data = await getCompanyConfig();
    if (data) {
      const traumaConfigStrings = normalizeTraumaCompanyConfigStrings({
        traumaNavigationTitle: data?.traumaNavigationTitle ?? null,
        traumaProductTitle: data?.traumaProductTitle ?? null,
        traumaProductDescription: data?.traumaProductDescription ?? null,
        traumaIntroQuestionTitle: data?.traumaIntroQuestionTitle ?? null,
        traumaIntroQuestionDescription: data?.traumaIntroQuestionDescription ?? null,
        traumaReferenceNumberLabel: data?.traumaReferenceNumberLabel ?? null,
        traumaCheckinIntervalsDays: data?.traumaCheckinIntervalsDays ?? null,
      });
      const speakUpConfigStrings = normalizeSpeakUpCompanyConfigStrings({
        speakUpButtonText: data?.speakUpButtonText ?? null,
        speakUpF2SUPopUpDescription: data?.speakUpF2SUPopUpDescription ?? null,
      });

      dispatch(
        companyConfigActions.updateConfigurationData({
          showInstantHelp: data.showInstantHelp,
          instantHelpDescription: data.instantHelpDescription,
          showSpeakUp: data.showSpeakUp,
          welcomeMessageText:
            data.welcomeMessageText &&
            data.welcomeMessageText.length > 0 &&
            data.welcomeMessageText !== 'null'
              ? data.welcomeMessageText
              : null,
          expertsEnabled: data.expertsEnabled,
          expertsEnabledbyTraumaOnly: Boolean(data.expertsEnabledbyTraumaOnly),
          talkToAdvisor: data.talkToAdvisor,
          talkToAdvisorMessage:
            data.talkToAdvisor &&
            data.talkToAdvisorMessage !== null &&
            data.talkToAdvisorMessage !== 'null' &&
            data.talkToAdvisorMessage !== undefined &&
            typeof data.talkToAdvisorMessage === 'string' &&
            data.talkToAdvisorMessage !== ' ' &&
            data.talkToAdvisorMessage !== ''
              ? data.talkToAdvisorMessage
              : TALK_TO_ADVISOR_DEFAULT_MESSAGE,
          talkToAdvisorCompleteMessage:
            data.talkToAdvisor &&
            data.talkToAdvisorCompleteMessage !== null &&
            data.talkToAdvisorCompleteMessage !== 'null' &&
            data.talkToAdvisorCompleteMessage !== undefined &&
            typeof data.talkToAdvisorCompleteMessage === 'string' &&
            data.talkToAdvisorCompleteMessage !== ' ' &&
            data.talkToAdvisorCompleteMessage !== ''
              ? data.talkToAdvisorCompleteMessage
              : TALK_TO_ADVISOR_COMPLETE_DEFAULT_MESSAGE,
          hideHapstarLogo: data.hideHapstarLogo ? data.hideHapstarLogo : false,
          hideFooterGraphic: data.hideFooterGraphic ? data.hideFooterGraphic : false,
          dashboardBgColour: data.dashboardBgColour
            ? data.dashboardBgColour
            : DEFAULT_HS_BLUE_COLOR,
          dashboardNewsOnTop: data.dashboardNewsOnTop ? data.dashboardNewsOnTop : false,
          platformName:
            data.platformName && data.platformName !== 'null' && data.platformName !== null
              ? data.platformName
              : null,
          shareThoughtOrganizationText:
            data.shareThoughtOrganizationText &&
            data.shareThoughtOrganizationText !== 'null' &&
            data.shareThoughtOrganizationText !== null
              ? data.shareThoughtOrganizationText
              : null,
          participantReportUserInsightsEnabled: data.participantReportUserInsightsEnabled
            ? data.participantReportUserInsightsEnabled
            : false,
          dashboardHeaderTextColor: data?.dashboardHeaderTextColor
            ? data?.dashboardHeaderTextColor
            : '#ffffff',
          communityEnabled: data?.communityEnabled ? data?.communityEnabled : false,
          communityMaxPostsPerDay: data?.communityMaxPostsPerDay
            ? data?.communityMaxPostsPerDay
            : 5,
          communityWelcomeText:
            data?.communityWelcomeText && data?.communityWelcomeText?.length > 1
              ? data?.communityWelcomeText
              : 'Share thoughts, ask questions, and connect with others in your organisation.',
          communityPostMessageText:
            data?.communityPostMessageText && data?.communityPostMessageText?.length > 1
              ? data?.communityPostMessageText
              : 'Share your thoughts with the community. Your post will be visible to others in your organisation.',
          freedomToSpeakUpEnabled: Boolean(data?.freedomToSpeakUpEnabled),
          ...speakUpConfigStrings,
          traumaEnabled: Boolean(data?.traumaEnabled),
          ...traumaConfigStrings,
          traumaAssessmentDelayHours: data?.traumaAssessmentDelayHours ?? 0,
          traumaHotPhaseDurationDays: data?.traumaHotPhaseDurationDays ?? 0,
          traumaWarmPhaseDurationDays: data?.traumaWarmPhaseDurationDays ?? 0,
          traumaColdPhaseDurationDays: data?.traumaColdPhaseDurationDays ?? 0,
          traumaTherapyEnabled: Boolean(data?.traumaTherapyEnabled),
          themePrimaryCTAColor: data?.themePrimaryCTAColor ?? null,
          themePrimaryCTAHoverColor: data?.themePrimaryCTAHoverColor ?? null,
          themeNavBackgroundColor: data?.themeNavBackgroundColor ?? null,
          themeSurfaceBackgroundColor: data?.themeSurfaceBackgroundColor ?? null,
          themeAccentIconBackgroundColor: data?.themeAccentIconBackgroundColor ?? null,
          themeBorderColor: data?.themeBorderColor ?? null,
        }),
      );
    } else {
      dispatch(companyConfigActions.setError({ error: 'Loading company configurations failed' }));
    }
  } catch (error) {
    dispatch(companyConfigActions.setError({ error: 'Loading company configurations failed' }));
  }
};
